"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.formatDomainToSubdomainForDisplay = formatDomainToSubdomainForDisplay;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _axios = _interopRequireDefault(require("axios"));

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _Tabs = require("./components/thought-industries/Tabs");

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _interfaces = require("@insided/deprecated-control/integrations/interfaces");

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ThoughtIndustriesIntegration = /*#__PURE__*/function (_Integration) {
  (0, _inherits2.default)(ThoughtIndustriesIntegration, _Integration);

  var _super = _createSuper(ThoughtIndustriesIntegration);

  function ThoughtIndustriesIntegration() {
    var _this;

    (0, _classCallCheck2.default)(this, ThoughtIndustriesIntegration);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.getInitialState());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkPanelHasUnsavedChanges", function () {
      var _this$state = _this.state,
          apiKey = _this$state.apiKey,
          subdomain = _this$state.subdomain,
          isFederatedSearchActive = _this$state.isFederatedSearchActive,
          storedState = _this$state.storedState;
      var hasApiTokenChanged = apiKey !== storedState.apiKey;
      var hasSubdomainChanged = subdomain !== storedState.subdomain;
      var hasFederatedSearchSettingChanged = isFederatedSearchActive !== storedState.isFederatedSearchActive;
      return hasApiTokenChanged || hasSubdomainChanged || hasFederatedSearchSettingChanged;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInstall", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state2, apiKey, subdomain, validatedFields, data, result, _result$data, _apiKey, domain, _subdomain, updatedStoredState, _error$response, _error$response$data, _this$state$storedSta, _apiKey2, _subdomain2, errorResponse;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.resetMessages();

              _this$state2 = _this.state, apiKey = _this$state2.apiKey, subdomain = _this$state2.subdomain;
              validatedFields = [];

              if (apiKey === '') {
                validatedFields.push({
                  field: 'apiKey',
                  message: 'Please enter an API key.'
                });
              }

              if (subdomain === '') {
                validatedFields.push({
                  field: 'subdomain',
                  message: 'Please enter a subdomain.'
                });
              }

              if (!_this.isInputInvalid(validatedFields)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              data = {
                apiKey: apiKey.trim(),
                subdomain: subdomain.trim()
              };
              _context.prev = 8;
              _context.next = 11;
              return _axios.default.post('/integration/thoughtindustries/install', data);

            case 11:
              result = _context.sent;
              _result$data = result.data, _apiKey = _result$data.apiKey, domain = _result$data.domain;
              _subdomain = formatDomainToSubdomainForDisplay(domain);
              updatedStoredState = _objectSpread({}, _this.state.storedState);
              updatedStoredState.apiKey = _apiKey;
              updatedStoredState.subdomain = _subdomain;

              _this.setState({
                isInstalled: !!(_apiKey && _subdomain),
                apiKey: _apiKey,
                subdomain: _subdomain,
                storedState: updatedStoredState,
                message: 'All set! Thought Industries installed.',
                messageType: 'success',
                errorFields: [],
                isSavingCredentials: false
              });

              _publish.default.trackEvent('userevent', {
                type: 'Thought Industries app installed'
              });

              _context.next = 26;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](8);
              _this$state$storedSta = _this.state.storedState, _apiKey2 = _this$state$storedSta.apiKey, _subdomain2 = _this$state$storedSta.subdomain;
              errorResponse = (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error;

              if (errorResponse !== null && errorResponse !== void 0 && errorResponse.toLowerCase().includes('base url')) {
                _this.setState({
                  errorFields: [{
                    field: 'subdomain',
                    message: _context.t0.response.data.error
                  }],
                  isInstalled: false,
                  isSavingCredentials: false
                });
              } else if (errorResponse !== null && errorResponse !== void 0 && errorResponse.toLowerCase().includes('api key')) {
                _this.setState({
                  errorFields: [{
                    field: 'apiKey',
                    message: _context.t0.response.data.error
                  }],
                  isInstalled: false,
                  isSavingCredentials: false
                });
              } else {
                _this.setState({
                  apiKey: _apiKey2,
                  subdomain: _subdomain2,
                  message: errorResponse || 'Sorry, something went wrong, please try again.',
                  messageType: 'error',
                  errorFields: [],
                  isSavingCredentials: false
                });
              }

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[8, 21]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetIntegrationTab", function (activeTab) {
      _this.resetFederatedSearchSetting();

      _this.setState({
        activeTab: activeTab
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetInstallationTab", function (activeTab) {
      _this.setState({
        apiKey: '',
        subdomain: '',
        showUnsavedChangesModal: false,
        errorFields: [],
        activeTab: activeTab
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUninstall", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var successMessage, errorMessage, updatedStoredState;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                messageType: undefined
              });

              successMessage = "You've uninstalled Thought Industries.";
              errorMessage = 'Sorry, something went wrong, please try again.';
              _context2.prev = 3;
              _context2.next = 6;
              return _axios.default.put('/integration/thoughtindustries/uninstall');

            case 6:
              updatedStoredState = _objectSpread({}, _this.state.storedState);
              updatedStoredState.isFederatedSearchActive = false;
              updatedStoredState.apiKey = '';
              updatedStoredState.subdomain = '';

              _this.setState({
                isInstalled: false,
                apiKey: '',
                subdomain: '',
                isFederatedSearchActive: false,
                storedState: updatedStoredState,
                showUninstallModal: false,
                messageType: 'success',
                message: successMessage
              });

              _context2.next = 17;
              break;

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](3);

              _logger.logger.error(_context2.t0, {
                component: 'ThoughtIndustriesIntegration',
                action: 'saveSettings'
              });

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showUninstallModal: false
              });

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 13]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetIntegrationPanelChanges", function (activeTab) {
      _this.setState({
        activePanel: undefined
      });

      var _this$state3 = _this.state,
          isFederatedSearchActive = _this$state3.isFederatedSearchActive,
          storedState = _this$state3.storedState;

      if (isFederatedSearchActive !== storedState.isFederatedSearchActive) {
        _this.resetFederatedSearchSetting();
      }

      if (_this.state.selectedTab !== undefined && _this.state.selectedTab !== _this.state.activeTab) {
        _this.setState({
          activeTab: activeTab
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetFederatedSearchSetting", function () {
      var _this$state4 = _this.state,
          storedState = _this$state4.storedState,
          selectedPanel = _this$state4.selectedPanel;

      _this.setState({
        isFederatedSearchActive: storedState.isFederatedSearchActive,
        filterQuery: storedState.filterQuery,
        showFederatedSearchActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveFederatedSearchSetting", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var errorMessage, _this$state5, isFederatedSearchActive, filterQuery, successMessage, updatedState, _this$state$storedSta2, _isFederatedSearchActive, _filterQuery;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                messageType: undefined,
                isSavingFederatedSearchSetting: true
              });

              errorMessage = "Something went wrong, setting can't be updated. Please try again.";
              _this$state5 = _this.state, isFederatedSearchActive = _this$state5.isFederatedSearchActive, filterQuery = _this$state5.filterQuery;
              _context3.prev = 3;
              _context3.next = 6;
              return _axios.default.post('/integration/thoughtindustries/saveFederatedSearchConf', {
                isActive: isFederatedSearchActive,
                filterQuery: filterQuery === null || filterQuery === void 0 ? void 0 : filterQuery.trim()
              });

            case 6:
              successMessage = 'Changes are saved successfully.';
              updatedState = _objectSpread(_objectSpread({}, _this.state.storedState), {}, {
                isFederatedSearchActive: isFederatedSearchActive,
                filterQuery: filterQuery
              });

              _this.setState({
                storedState: updatedState,
                message: successMessage,
                messageType: 'success',
                showFederatedSearchActionButtons: false,
                isSavingFederatedSearchSetting: false,
                federatedSearchInitialSyncCompleted: true
              });

              _publish.default.trackEvent('userevent', {
                type: "Thought Industries federated search ".concat(isFederatedSearchActive ? 'enabled' : 'disabled')
              });

              _context3.next = 16;
              break;

            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](3);
              _this$state$storedSta2 = _this.state.storedState, _isFederatedSearchActive = _this$state$storedSta2.isFederatedSearchActive, _filterQuery = _this$state$storedSta2.filterQuery;

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showFederatedSearchActionButtons: false,
                isSavingFederatedSearchSetting: false,
                isFederatedSearchActive: _isFederatedSearchActive,
                filterQuery: _filterQuery,
                federatedSearchInitialSyncCompleted: false
              });

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[3, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dismissMessage", function () {
      _this.setState({
        messageType: undefined,
        message: ''
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFilterChange", function (value) {
      _this.setState({
        showFederatedSearchActionButtons: true,
        showFilterWarning: !value.includes('status:'),
        filterQuery: value
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ThoughtIndustriesIntegration, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props$enabledFe, _this$props$apiKey, _this$props$enabledFe2, _this$props$apiKey2;

      var subdomain = this.props.domain ? formatDomainToSubdomainForDisplay(this.props.domain) : '';

      var initialState = _objectSpread(_objectSpread({}, this.getBaseInitialState()), {}, {
        isInstalled: !!(this.props.apiKey && this.props.domain),
        isFederatedSearchActive: (_this$props$enabledFe = this.props.enabledFederatedSearch) !== null && _this$props$enabledFe !== void 0 ? _this$props$enabledFe : false,
        apiKey: (_this$props$apiKey = this.props.apiKey) !== null && _this$props$apiKey !== void 0 ? _this$props$apiKey : '',
        subdomain: subdomain !== null && subdomain !== void 0 ? subdomain : '',
        filterQuery: this.props.filterQuery === undefined ? 'status:published' : this.props.filterQuery,
        showFederatedSearchActionButtons: false,
        showFilterWarning: false,
        federatedSearchInitialSyncCompleted: false,
        storedState: {
          isFederatedSearchActive: (_this$props$enabledFe2 = this.props.enabledFederatedSearch) !== null && _this$props$enabledFe2 !== void 0 ? _this$props$enabledFe2 : false,
          apiKey: (_this$props$apiKey2 = this.props.apiKey) !== null && _this$props$apiKey2 !== void 0 ? _this$props$apiKey2 : '',
          subdomain: subdomain !== null && subdomain !== void 0 ? subdomain : '',
          filterQuery: this.props.filterQuery === undefined ? 'status:published' : this.props.filterQuery
        }
      });

      return initialState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state6 = this.state,
          isInstalled = _this$state6.isInstalled,
          messageType = _this$state6.messageType,
          message = _this$state6.message,
          activeTab = _this$state6.activeTab,
          showUninstallModal = _this$state6.showUninstallModal,
          apiKey = _this$state6.apiKey,
          subdomain = _this$state6.subdomain,
          errorFields = _this$state6.errorFields,
          showUnsavedChangesModal = _this$state6.showUnsavedChangesModal,
          isSavingCredentials = _this$state6.isSavingCredentials,
          isFederatedSearchActive = _this$state6.isFederatedSearchActive,
          showFederatedSearchActionButtons = _this$state6.showFederatedSearchActionButtons,
          showFilterWarning = _this$state6.showFilterWarning,
          isSavingFederatedSearchSetting = _this$state6.isSavingFederatedSearchSetting,
          filterQuery = _this$state6.filterQuery,
          storedState = _this$state6.storedState,
          activePanel = _this$state6.activePanel,
          federatedSearchInitialSyncCompleted = _this$state6.federatedSearchInitialSyncCompleted;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.state.storedState.isFederatedSearchActive ? 1 : 0;
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Thought Industries",
        appLogoName: "thought-industries-l",
        appContainerBackgroundColor: "#233746",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this2.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this2.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_Tabs.IntegrationTab, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isFederatedSearchActive: isFederatedSearchActive,
          showActionButtons: showFederatedSearchActionButtons,
          onSave: this.saveFederatedSearchSetting,
          onCancel: function onCancel() {
            return _this2.resetFederatedSearchSetting();
          },
          onSettingChanged: function onSettingChanged() {
            return _this2.onFederatedSearchSettingChanged(!isFederatedSearchActive);
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          showFilterWarning: showFilterWarning,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetIntegrationTab(1);
          },
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          onClickPanelCallback: function onClickPanelCallback(selectedPanel) {
            return _this2.setSelectedPanel(selectedPanel);
          },
          storedState: storedState,
          filterQuery: filterQuery,
          onFilterChange: this.onFilterChange,
          federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted
        }), (0, _preact.h)(_Tabs.InstallationTab, {
          key: "installationTab",
          apiKey: apiKey,
          subdomain: subdomain,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.onInstall();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this2.onResetInstallationTab(1);
          },
          onApiKeyChangeCallback: function onApiKeyChangeCallback(value) {
            return _this2.setState({
              apiKey: value
            });
          },
          onApiKeyClickCallback: function onApiKeyClickCallback() {
            _this2.removeValidationErrorFromInputField('apiKey');
          },
          onSubdomainChangeCallback: function onSubdomainChangeCallback(value) {
            return _this2.setState({
              subdomain: value
            });
          },
          onSubdomainClickCallback: function onSubdomainClickCallback() {
            return _this2.removeValidationErrorFromInputField('subdomain');
          },
          onClickManage: function onClickManage() {
            return _this2.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this2.onClickUninstallButton();
          },
          errorFields: errorFields,
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: function displayUnsavedChangedModal() {
            return _this2.displayUnsavedChangedModal();
          },
          closeModal: function closeModal() {
            return _this2.closeModal();
          },
          resetChanges: function resetChanges() {
            return _this2.onResetInstallationTab(0);
          },
          isSavingCredentials: isSavingCredentials
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Thought Industries",
          onUninstall: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
            return _regenerator.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _this2.onUninstall();

                  case 2:
                    return _context5.abrupt("return", _context5.sent);

                  case 3:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          })),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this2.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return ThoughtIndustriesIntegration;
}(_interfaces.Integration);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Thought Industries helps organizations of all sizes build successful, long-term customer and partner relationships through engaging learning experiences tailored to the individual, team, industry, geography or subject matter.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Thought Industries integration, you can easily setup a federated search. Your customers can seamlessly search for Thought Industries courses through your", ' ', _constants.PLATFORM_BRAND_NAME, "."));
};

function formatDomainToSubdomainForDisplay(domain) {
  if (domain.includes('.eu.')) {
    return domain.split('.eu.')[0] + '.eu';
  }

  return domain.split('.')[0];
}

var _default = ThoughtIndustriesIntegration;
exports.default = _default;